/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, region: NonNullable<unknown>, to: NonNullable<unknown> }} Progression_Substituted_PainInputs */

const en_us2_progression_substituted_pain = /** @type {(inputs: Progression_Substituted_PainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} hurt your ${i?.region}, so next time it's ${i?.to}`)
};

const pt_br2_progression_substituted_pain = /** @type {(inputs: Progression_Substituted_PainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} doeu no ${i?.region}; na próxima será ${i?.to}`)
};

const es_419_progression_substituted_pain = /** @type {(inputs: Progression_Substituted_PainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} te causó dolor en ${i?.region}; la próxima vez será ${i?.to}`)
};

const pt_pt2_progression_substituted_pain = /** @type {(inputs: Progression_Substituted_PainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} causou dor no ${i?.region}; na próxima será ${i?.to}`)
};

const fr_fr2_progression_substituted_pain = /** @type {(inputs: Progression_Substituted_PainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} t'a fait mal (${i?.region}), la prochaine fois ce sera ${i?.to}`)
};

const de_de2_progression_substituted_pain = /** @type {(inputs: Progression_Substituted_PainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} hat Schmerzen verursacht (${i?.region}), daher nächstes Mal ${i?.to}`)
};

const it_it2_progression_substituted_pain = /** @type {(inputs: Progression_Substituted_PainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} ti ha fatto male (${i?.region}), quindi la prossima volta sarà ${i?.to}`)
};

/**
* | output |
* | --- |
* | "{from} hurt your {region}, so next time it's {to}" |
*
* @param {Progression_Substituted_PainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_substituted_pain = /** @type {((inputs: Progression_Substituted_PainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Substituted_PainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_substituted_pain(inputs)
	if (locale === "es-419") return es_419_progression_substituted_pain(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_substituted_pain(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_substituted_pain(inputs)
	if (locale === "de-DE") return de_de2_progression_substituted_pain(inputs)
	if (locale === "it-IT") return it_it2_progression_substituted_pain(inputs)
	return en_us2_progression_substituted_pain(inputs)
});
export { progression_substituted_pain as "progression.substituted_pain" }